import React from "react";
import Icon from "../Icon";
import * as styles from "../../styles/components/MyAccount.css";

export default class MyAccountNav extends React.PureComponent {
    render() {
        return (
            <div className={styles.accountNav}>
                <div className={`${styles.navItem} ${styles.isSelected}`}>
                    <div className={styles.icon}>
                        <Icon icon="user" />
                    </div>
                    <p className={styles.label}>My Profile</p>
                </div>
                <button
                    className={`${styles.navItem} ${styles.startSection}`}
                    onClick={this.props.logOut}
                    role="button"
                >
                    <div className={styles.icon}>
                        <Icon icon="sign-out" />
                    </div>
                    <p className={styles.label}>Log Out</p>
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyAccountNav.js